module.exports = __webpack_public_path__ + "india.d51ec02e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/countries/india.png
// module id = 125
// module chunks = 0